export function FullScreenLoader() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "var(--page-bg)",
      }}
    >
      <div className="spinner" aria-label="Cargando" />
    </div>
  );
}
